import LoadingSpinner from './LoadingSpinner';

const TextWithSuggestionsField = ({ field, value, onChange, onFocus, loading, isLoading }) => {
  const { name, label } = field;
  const options = field.options || [];

  return (
    <div className="relative">
      <input
        type="text"
        name={name}
        placeholder={label}
        value={value ?? ''}
        onChange={onChange}
        onFocus={onFocus}
        disabled={loading || isLoading}
        className="w-full px-3 py-2 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
        list={`${name}-options`}
      />
      <datalist id={`${name}-options`}>
        {options.map((option, index) => (
          <option key={index} value={option.value} />
        ))}
      </datalist>
      {isLoading && <LoadingSpinner />}
    </div>
  );
};

export default TextWithSuggestionsField;
